import { BadgeId, BadgesStats } from '../Models';
import { WritingBadge } from './WritingBadge';

export default class KumamonBadge extends WritingBadge {
  public readonly id = BadgeId.kumamon;

  public evaluateIfAchieved = (stats: BadgesStats) => {
    return stats.streakInfo.current >= 5 || stats.streakInfo.longest >= 5;
  };
}



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/kumamon.ts